module.exports = {
          srcSet: __webpack_public_path__ + "e60f2661f5eaaa4c8e6da695f8dd8e4d-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "e60f2661f5eaaa4c8e6da695f8dd8e4d-120.png",width: 120,height: 144}],
          src: __webpack_public_path__ + "e60f2661f5eaaa4c8e6da695f8dd8e4d-120.png",
          toString:function(){return __webpack_public_path__ + "e60f2661f5eaaa4c8e6da695f8dd8e4d-120.png"},
          
          width: 120,
          height: 144
        }